export default __webpack_public_path__ + "alerttriangle.e3483efc.svg";